// Library Import
import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

// Local Imports

const API = import.meta.env.VITE_SERVER_CON_URL;

export const addChallenge = createAsyncThunk(
  "addChallenge",
  async ({
    challengeName,
    challengeDesc,
    difficultyLev,
    score,
    startDate,
    endDate,
    timeDur,
    challengeId,
    language,
    tags,
  }) => {
    try {
      const response = await axios.post(`${API}/api/admin/addChallenge`, {
        challengeName,
        challengeDesc,
        difficultyLev,
        score,
        startDate,
        endDate,
        timeDur,
        challengeId,
        language,
        tags,
      });

      return response.data;
    } catch (err) {
      return {
        err:
          err.response && err.response.data.message
            ? err.response.data.message
            : err.message,
      };
    }
  }
);

export const getChallenge = createAsyncThunk(
  "getChallenge",
  async (challengeId) => {
    try {
      const response = await axios.post(`${API}/api/admin/getChallenge`, {
        challengeId,
      });

      return response.data;
    } catch (err) {
      return {
        err:
          err.response && err.response.data.message
            ? err.response.data.message
            : err.message,
      };
    }
  }
);

export const deleteChallenge = createAsyncThunk(
  "deleteChallenge",
  async (challengeId) => {
    try {
      const response = await axios.post(
        `${API}/api/admin/deleteChallenge?challengeId=${challengeId}`
      );

      return response.data;
    } catch (err) {
      return {
        err:
          err.response && err.response.data.message
            ? err.response.data.message
            : err.message,
      };
    }
  }
);

export const updateChallenge = createAsyncThunk(
  "updateChallenge",
  async (challenge, { dispatch }) => {
    try {
      const response = await axios.post(`${API}/api/admin/updateChallenge`, {
        ...challenge,
      });

      return response.data;
    } catch (err) {
      return {
        err:
          err.response && err.response.data.message
            ? err.response.data.message
            : err.message,
      };
    }
  }
);

export const downloadExcelTemplate = createAsyncThunk(
  "downloadExcelTemplate",
  async () => {
    try {
      const response = await axios.get(
        `${API}/api/admin/downloadExcelTemplate`,
        {
          responseType: "blob",
        }
      );

      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", "Template.csv"); // Set the downloaded file name
      document.body.appendChild(link);
      link.click();
      link.remove();

      return decryptResponse(response.data);
    } catch (err) {
      return {
        err:
          err.response && err.response.data.message
            ? err.response.data.message
            : err.message,
      };
    }
  }
);

export const uploadFileData = createAsyncThunk(
  "uploadFileData",
  async ({ file: excelFile }) => {
    try {
      const formData = new FormData();
      formData.append("file", excelFile);

      const response = await axios.post(
        `${API}/api/admin/uploadFileData`,
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      );

      return response.data;
    } catch (err) {
      return {
        err:
          err.response && err.response.data.message
            ? err.response.data.message
            : err.message,
      };
    }
  }
);

export const getTotalStudentCount = createAsyncThunk(
  "getTotalStudentCount",
  async () => {
    try {
      const response = await axios.get(`${API}/api/admin/getTotalStudentCount`);

      return response.data;
    } catch (err) {
      return {
        err:
          err.response && err.response.data.message
            ? err.response.data.message
            : err.message,
      };
    }
  }
);
